// Entry point for the build script in your package.json
import { Turbo } from "@hotwired/turbo-rails"
Turbo.session.drive = false // Disable Turbo Drive — server-rendered Liquid pages don't benefit from SPA caching
import "./controllers"
